var getSubMenuParent = function getSubMenuParent(sourceElement) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
  // not able to use closest api since it could be the original parent submenu when we query submenu-wrapper
  var isSourceSubMenu = (_c = (_b = (_a = sourceElement.parentElement) === null || _a === undefined ? undefined : _a.parentElement) === null || _b === undefined ? undefined : _b.parentElement) === null || _c === undefined ? undefined : _c.classList.contains('submenu-wrapper');
  if (isSourceSubMenu) {
    return (_l = (_k = (_j = (_h = (_g = (_f = (_e = (_d = sourceElement.parentElement) === null || _d === undefined ? undefined : _d.parentElement) === null || _e === undefined ? undefined : _e.parentElement) === null || _f === undefined ? undefined : _f.parentElement) === null || _g === undefined ? undefined : _g.parentElement) === null || _h === undefined ? undefined : _h.parentElement) === null || _j === undefined ? undefined : _j.parentElement) === null || _k === undefined ? undefined : _k.parentElement) === null || _l === undefined ? undefined : _l.parentElement;
  }
  return (_r = (_q = (_p = (_o = (_m = sourceElement.parentElement) === null || _m === undefined ? undefined : _m.parentElement) === null || _o === undefined ? undefined : _o.parentElement) === null || _p === undefined ? undefined : _p.parentElement) === null || _q === undefined ? undefined : _q.parentElement) === null || _r === undefined ? undefined : _r.parentElement;
};
var isSameMenuItem = function isSameMenuItem(relevantParent, actualOwner) {
  if (actualOwner === null) return false;
  var relevantParentInnerText = relevantParent === null || relevantParent === undefined ? undefined : relevantParent.getElementsByClassName('cogs-menu-item__content__title')[0].innerHTML;
  var actualOwnerInnerText = actualOwner.getElementsByClassName('cogs-menu-item__content__title')[0].innerHTML;
  return relevantParentInnerText === actualOwnerInnerText;
};
var focusBackward = function focusBackward(relevantParent) {
  // at this time we know its going to be a submenu item. Therefore going to query for the first menu item
  var menuItem = relevantParent.getElementsByClassName('cogs-menu-item')[0];
  if (menuItem) {
    menuItem.focus();
  }
};
/**
 * need to change the text comparison logic to something more robust
 * @param submenuItem - reference of the current submenu item
 * @param eventOwner - owner of the forward event triggerd
 * @returns
 */
var focusForward = function focusForward(submenuItem, eventOwner) {
  var IsSameSubMenuEvent = isSameMenuItem(eventOwner, submenuItem);
  if (!IsSameSubMenuEvent) return;
  var subMenu = submenuItem.getElementsByClassName('cogs cogs-menu')[0];
  if (subMenu) {
    var firstSubMenuItem = subMenu.childNodes[0];
    var isAnotherSubMenu = firstSubMenuItem.classList.contains('submenu-wrapper');
    if (isAnotherSubMenu) {
      // need to search for the menu item inside the submenu to focus on it's menu item.
      var otherSubmenuItem = firstSubMenuItem.getElementsByClassName('cogs-menu-item')[0];
      otherSubmenuItem.focus();
    } else {
      firstSubMenuItem.focus();
    }
  }
};
var isItChild = function isItChild(element, parent) {
  var _a;
  var childId = element.id;
  if (!childId) {
    var elementWithId = (_a = element.parentElement) === null || _a === undefined ? undefined : _a.closest('[id]');
    if (elementWithId) {
      childId = elementWithId.id;
    }
  }
  try {
    // check if this element that belongs to this id exists inside our parent
    var child = parent.querySelector("#" + childId);
    return !!child;
  } catch (_b) {
    // this usually happens when the childId starts with a digit
    return false;
  }
};

export { focusBackward, focusForward, getSubMenuParent, isItChild, isSameMenuItem };
